import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Language } from 'src/app/tools/language/language';
import { dataText } from './dataText';

@Component({
  selector: 'app-modal-information',
  templateUrl: './modal-information.component.html',
  styleUrls: ['./modal-information.component.scss']
})
export class ModalInformationComponent implements OnInit {
  lang: any = Language.currentLanguage.lenid;
  title: string;
  text: string;
  buttonTitle: string;
  index = 0;

  constructor(
    public dialogRef: MatDialogRef<ModalInformationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    const { id } = this.data;
    this.index = id;
    if (this.lang === 'es') {
      this.title = dataText[this.index].es.title;
      this.text = dataText[this.index].es.text;
      this.buttonTitle = dataText[this.index].es.buttonTitle;
    } else if (this.lang === 'en') {
      this.title = dataText[this.index].en.title;
      this.text = dataText[this.index].en.text;
      this.buttonTitle = dataText[this.index].en.buttonTitle;
    } else if (this.lang === 'pt') {
      this.title = dataText[this.index].pt.title;
      this.text = dataText[this.index].pt.text;
      this.buttonTitle = dataText[this.index].pt.buttonTitle;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
